<template>
  <div id="app">
    <!-- 导航栏 -->
    <navbar :position="position" type="primary" menu-classes="ml-auto" :transparent="isTransparent"
            :color-on-scroll="colorOnScroll" style="padding: 0px; margin: 0px;">
      <div class="navbar-translate navbar-brand">
<!--        <a class="mr-3" href="/" style="margin-left: -30px"><img src="/resource_social22/img/logo_polyu.png"-->
<!--                                                                 width="20%"></a>-->
<!--        <a href="/"><img src="/resource_social22/img/logo_fudan.png" width="15%"></a>-->
      </div>
      <template slot="navbar-menu">
        <li class="nav-item">
          <router-link class="nav-link" to="/">
            <p>Home</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/task">
            <p>Task & Data</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/leaderboard">
            <p>Leaderboard</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/workshop">
            <p>Workshop</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/organization">
            <p>Organizer</p>
          </router-link>
        </li>
        <li class="nav-item" v-if="loginState">
          <router-link class="nav-link" to="/console">
            <p>Console</p>
          </router-link>
        </li>
        <li class="nav-item" v-if="loginState">
          <el-tooltip class="item" content="Logout" placement="bottom">
            <a class="nav-link" @click="logout" href="">
              <i class="now-ui-icons arrows-1_share-66" aria-hidden="true"></i>
            </a>
          </el-tooltip>
        </li>

        <li class="nav-item" v-else>
          <el-tooltip class="item" content="Login/Regist" placement="bottom">
            <router-link class="nav-link" to="/login">
              <i class="now-ui-icons users_single-02" aria-hidden="true"></i>
            </router-link>
          </el-tooltip>

        </li>

      </template>
      <!--      <template slot="navbar-menu">-->
      <!--        <drop-down tag="li" title="Sample Dropdown">-->
      <!--          <nav-link class="dropdown-item">-->
      <!--            <i class="now-ui-icons shopping_box"></i> Headers-->
      <!--          </nav-link>-->
      <!--        </drop-down>-->
      <!--      </template>-->
    </navbar>

    <!-- 主体 -->
    <!--    <div class="section text-center">-->
    <!--      <h3>Create your next awesome website</h3>-->
    <!--    </div>-->
    <div class="">
      <router-view></router-view>
    </div>
    <!-- 页脚 -->
    <footer class="footer" :class="{ [`footer-${type}`]: type }" :data-background-color="backgroundColor"
            v-if="isShowFooter">
      <div class="container">
        <!--        <nav>-->
        <!--          <ul>-->
        <!--            <li>-->
        <!--              <a href="https://www.creative-tim.com">-->
        <!--                Creative Tim-->
        <!--              </a>-->
        <!--            </li>-->
        <!--            <li>-->
        <!--              <a href="https://www.creative-tim.com/license">-->
        <!--                License-->
        <!--              </a>-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </nav>-->
        <div class="copyright">
          &copy; Shanghai-HK Interdisciplinary Shared Tasks (2022)
<!--          Copyright owned by-->
<!--          <a href="https://polyusmart.net/" target="_blank" rel="noopener">PolyU SMART</a>-->
<!--          and-->
<!--          <a href="http://fudan-disc.com/" target="_blank" rel="noopener">Fudan DISC</a>.-->
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import {DropDown, NavbarToggleButton, Navbar, NavLink} from '@/components';
import {Popover, Tooltip} from 'element-ui';

export default {
  name: 'starter',
  components: {
    // DropDown,
    Navbar,
    // NavbarToggleButton,
    // NavLink,
    [Tooltip.name]: Tooltip,
    [Popover.name]: Popover
  },
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear(),
      isTransparent: false,
      isShowFooter: true,
      isLogin: false,
      colorOnScroll: 0,
      position: 'fixed',
    };
  },

  methods: {
    judgeNav() {
      if (this.$route.name == "indexHome" || this.$route.name == "indexLogin" || this.$route.name == "indexRegist") {
        this.isTransparent = false;
        this.position = 'fixed';
        this.colorOnScroll = 200;
      } else {
        this.isTransparent = false;
        this.position = 'stick-top';
        this.colorOnScroll = 0;
      }

      if (this.$route.name == "indexLogin" || this.$route.name == "indexRegist") {
        this.isShowFooter = false;
      } else {
        this.isShowFooter = true;
      }
    },

    logout() {
      this.$store.commit('removeLoginInfo');
      this.$router.push({name: 'indexHome'});
      localStorage.clear();
    }
  },

  computed: {
    loginState() {
      return this.$store.state.isLogin;
    }
  },

  mounted() {
    this.judgeNav();
    if (localStorage.is_login) {
      this.$store.commit('addLoginInfo');
    } else {
      this.$store.commit('removeLoginInfo');
    }
  },

  watch: {
    $route: { // 监听路由变化
      handler: function (val, oldVal) {
        this.judgeNav()
      },
      deep: true,
    },
  },
};
</script>
<style>
body {
  padding: 0;
}

.container {
  padding: 0;
}

.starter-page {
  min-height: calc(100vh - 95px);
}
</style>
